import MobileHeader from './components/MobileHeader.css';
export default {
    MobileHeader: MobileHeader
};
